import { Box, Button, Container, Grid, Link, Sheet, Stack, Typography } from '@mui/joy';
import {
    Star,
    Quotes
} from '@phosphor-icons/react';
import { FadeIn } from './FadeIn';

const REVIEWS = [
    {
        name: 'Максим Ефимцев',
        handle: '@mazgim',
        link: 'https://aquarium.org.ru/show/id/168',
        avatar: '/img/welcome/maxim.jpg',
        text: 'Реально крутой мессенджер. Давно такого кайфа не ловил. Летает мгновенно, ничего не тупит, интерфейс удобный — всё под рукой. Никакой рекламы, никакого мусора. Файлы любые кидаются без сжатия, звонки чистые. Короче, сделали со вкусом. Всё, что нужно, есть, а лишнего — нет. Перешёл полностью, и ни разу не пожалел. Советую'
    },
    {
        name: 'Александра Бирюкова',
        handle: '@saneka',
        avatar: '/img/welcome/sasha.png',
        link: 'https://aquarium.org.ru/show/id/94',
        text: 'Я открыла для себя приложение аквариум, очень удобное в плане того, что нету ничего лишнего, не съедает качество фотографий. Это приложение вызывает у меня только спокойствие. Буду общаться со своими друзьями!'
    },
    {
        name: 'Никита Сергеев',
        handle: '@nikitascrgccv',
        avatar: '/img/welcome/nikita.webp',
        link: 'https://aquarium.org.ru/show/id/194',
        text: 'Очень удобная авторизация. Вход буквально в один клик. Приятный интерфейс. Порадовала эстетичная колористика предлагаемых тем оформления. Грамотно устроена система поиска записей. Градация по интересующим темам помогает найти то, что действительно интересно.'
    },
];

export function ReviewsSection() {
    return (
        <Container maxWidth="lg">
            <Box sx={{ my: { md: 12, xs: 6 } }}>
                <FadeIn>
                    <Stack alignItems="center" spacing={1.5} sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
                        <Stack direction="row" spacing={0.5} sx={{ color: '#f5a524' }}>
                            {[0, 1, 2, 3, 4].map((i) => (
                                <Star key={i} size={22} weight="fill" />
                            ))}
                        </Stack>
                        <Typography level="h2" sx={{ fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.5rem' }, m: 0 }}>
                            О чём говорят пользователи
                        </Typography>
                        <Typography level="body-lg" sx={{ color: 'text.secondary', maxWidth: 600 }}>
                            Аквариум про спокойное общение без гонки за охватами.{' '}<br />
                            Личное сообщество, где общаются по-человечески.
                        </Typography>
                    </Stack>
                </FadeIn>
                <Grid container spacing={3}>
                    {REVIEWS.map((r, i) => (
                        <Grid key={r.handle} xs={12} md={4}>
                            <FadeIn delay={i * 0.1}>
                                <Sheet
                                    variant="soft"
                                    sx={{
                                        p: 3.5,
                                        height: '100%',
                                        borderRadius: '24px',
                                        backgroundColor: 'rgba(89, 160, 244, 0.07)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <Quotes size={28} weight="fill" color="var(--joy-palette-primary-400)" style={{ marginBottom: 12 }} />
                                    <Typography level="body-md" sx={{ mb: 3, flex: 1 }}>
                                        {r.text}
                                    </Typography>
                                    <Link
                                        href={r.link}
                                        target="_blank"
                                        sx={{
                                            borderRadius: '99px',
                                            textDecoration: 'none !important',
                                            maxWidth: 'fit-content',
                                            pr: 2
                                        }}
                                    >
                                        <Stack direction="row" spacing={1.5} alignItems="center">
                                            <Box
                                                component="img"
                                                src={r.avatar}
                                                alt={r.name}
                                                sx={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }}
                                            />
                                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                <Typography level="title-sm" sx={{ fontWeight: 700 }}>{r.name}</Typography>
                                                <Typography level="body-xs" sx={{ color: 'text.tertiary' }}>{r.handle}</Typography>
                                            </Box>
                                        </Stack>
                                    </Link>
                                </Sheet>
                            </FadeIn>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>
    );
}
